






































































import { Component, Vue } from "vue-property-decorator";
import Card from "./Card.vue";
import { namespace } from "vuex-class";
import { postRequestMagicLink } from "../api";

const globalStore = namespace("global");

@Component({ components: { Card } })
export default class LoginForm extends Vue {
  @globalStore.Getter applicationName!: string;

  emailAddress = "";
  send = false;
  success = false;
  loading = false;
  partialToken = "";
  tokenSuffix = "";
  accessTextKey = "base.pages.loginRequest.success";

  reset(): void {
    this.send = false;
    this.success = false;
  }

  mounted(): void {
    if (!this.$route.query.email) return;
    this.emailAddress = this.$route.query.email as string;
    this.login();
    this.accessTextKey = "base.pages.loginRequest.successLanding";
    this.$router.replace({ query: undefined });
  }

  async login(): Promise<void> {
    this.loading = true;
    try {
      const res = await postRequestMagicLink(this.emailAddress.trim());
      this.partialToken = res.partial_token;
      this.success = true;
    } catch (e) {
      this.success = false;
    }
    this.send = true;
    this.loading = false;
  }

  async tokenRedirect(): Promise<void> {
    const token = this.partialToken + this.tokenSuffix.trim();
    const suffix = this.tokenSuffix;
    this.$router.push({
      name: "login-process-token",
      params: { token, suffix },
    });
  }
}
